import { chromosomeDnaModule } from "./chromosomeDna";
import { chromosomeDna2Module } from "./chromosomeDna2";
import { chromosomeDna3Module } from "./chromosomeDna3";
import { chromosomeDna4Module } from "./chromosomeDna4";
import { chromosomeDna5Module } from "./chromosomeDna5";
import { chromosomeDna6Module } from "./chromosomeDna6";
import { methylationModule } from "./methylation";
import { rnaModule } from "./rna";
import { proteinModule } from "./protein";

export const geneticsMethodsModules = [
  chromosomeDnaModule,
  chromosomeDna2Module,
  chromosomeDna3Module,
  chromosomeDna4Module,
  chromosomeDna5Module,
  chromosomeDna6Module,
  methylationModule,
  rnaModule,
  proteinModule,
];
